import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const navLinks = [{
  label: 'NUTRISIB Club',
  href: 'https://nutrisib.club/celos'
}, {
  label: 'Evaluare Avansată',
  href: 'https://nutrisib.club/evaluare'
}, {
  label: 'Resurse Gratuite',
  href: 'https://nutrisib.club/blog/'
}, {
  label: 'Despre Mine',
  href: 'https://nutrisib.club/povestea'
}];
export function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-border-subtle" data-id="element-187">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-16" data-id="element-188">
        {/* Logo */}
        <a href="#" className="font-montserrat font-bold text-xl text-navy tracking-widest" data-id="element-189">
          NUTRISIB
        </a>

        {/* Desktop Links */}
        <div className="hidden lg:flex items-center gap-8" data-id="element-190">
          {navLinks.map(link => <a key={link.label} href={link.href} className="font-inter text-[17px] text-text-medium hover:text-navy transition-colors duration-200" data-id="element-191">
              {link.label}
            </a>)}
        </div>

        {/* Desktop CTA */}
        <div className="hidden lg:block" data-id="element-192">
          <a href="https://nutrisib.club/evaluare" className="bg-gold text-navy font-inter font-bold text-[17px] uppercase tracking-wide px-6 py-2.5 rounded-md hover:-translate-y-0.5 hover:shadow-md transition-all duration-200 no-underline" data-id="element-193">
            Evaluare
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button onClick={() => setMobileOpen(!mobileOpen)} className="lg:hidden text-navy p-2" aria-label="Toggle menu" data-id="element-194">
          {mobileOpen ? <XIcon className="w-6 h-6" data-id="element-195" /> : <MenuIcon className="w-6 h-6" data-id="element-196" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-197">
        {mobileOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeInOut'
      }} className="lg:hidden bg-white border-b border-border-subtle overflow-hidden" data-id="element-198">
            <div className="px-6 py-6 flex flex-col gap-4" data-id="element-199">
              {navLinks.map(link => <a key={link.label} href={link.href} className="font-inter text-[17px] text-text-medium hover:text-navy transition-colors" onClick={() => setMobileOpen(false)} data-id="element-200">
                  {link.label}
                </a>)}
              <a href="https://nutrisib.club/evaluare" className="mt-2 bg-gold text-navy font-inter font-bold text-[17px] uppercase tracking-wide px-6 py-3 rounded-md text-center hover:shadow-md transition-all duration-200 no-underline" onClick={() => setMobileOpen(false)} data-id="element-201">
                Evaluare
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}